/** @format */

import React, { useState, useEffect, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";

import { BrowserRouter as Router, Link, Route } from "react-router-dom";

export const SetApprovers = () => {
  const [positions, setPositions] = useState([]);
  const [appAddData, setAppAddData] = useState({
    posTitleSend: null,
    posIdSend: null,
  });

  async function getPositions() {
    try {
      const getPos = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/getPositions`
      );
      const parsRes = await getPos.json();
      setPositions(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/approvers`
    );
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  const setPosToApp = async () => {
    // set privilege
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/addApprover`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(appAddData),
      }
    );
    if (response.ok) {
      fetchAppro();
    }
  };

  const handlePosAddSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    getPositions();
    fetchAppro();
    document.getElementById("add-approver-btn").disabled = true;
  }, []);

  const getPosTitle = (posId) => {
    let posTitle = "";
    for (let i = 0; i < positions.length; i++) {
      if (positions[i].role_id == posId) {
        posTitle = positions[i].role_name;
      }
    }
    return posTitle;
  };

  const handlePosSelect = (e) => {
    document.getElementById("add-approver-btn").disabled = false;
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].app_title == getPosTitle(e.target.value)) {
        console.log(getPosTitle(e.target.value));

        document.getElementById("add-approver-btn").disabled = true;
      }
    }
    setAppAddData({
      ...appAddData,
      posTitleSend: getPosTitle(e.target.value),
      posIdSend: e.target.value,
    });
  };
  //   console.log(approvers)

  const handleAppAdd = (e) => {
    e.preventDefault();
    setPosToApp();
    fetchAppro();
    document.getElementById("add-approver-btn").disabled = true;
  };

  return (
    <Fragment>
      <div className="set-app-main-container">
        <h5 className="pos-submit-title text-center">
          Designer les approbateurs
        </h5>

        <div className="set-app-display form-control">
          <div className="select-submitBtn-container form-control">
            <div className="pos-select">
              <label className="position-select-label " for="position-select">
                Position:
              </label>
              <select
                id="position-select"
                className="position-select form-control"
                onChange={handlePosSelect}
              >
                <option id="default-option" disabled selected>
                  {" "}
                  --Selectioner--{" "}
                </option>
                {positions.map((position) => (
                  <option key={position.role_id} value={position.role_id}>
                    {position.role_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="add-approver-btn">
              <button
                className="btn btn-primary"
                id="add-approver-btn"
                onClick={handleAppAdd}
              >
                Ajouter
              </button>
            </div>
          </div>

          <div className="approvers-list">
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Approbateur</th>
                </tr>
              </thead>
              <tbody>
                {approvers.map((approver, index) => (
                  <tr key={approver.app_id}>
                    <td>{index + 1}</td>
                    <td>{approver.app_title}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
